import { ActionIcon, Anchor, Flex, Group, Text, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconBrandInstagram, IconBrandLinkedin } from '@tabler/icons-react';
import React from 'react';

const Footer: React.FC = () => {
	const theme = useMantineTheme();
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	return (
		<Flex justify="space-between" align="center" style={{
			width: '100%',
			borderTop: '1px solid #eee',
			background: '#fff',
			boxSizing: 'border-box',
			flexWrap: "nowrap",
			gap: 16,
			overflow: 'hidden',
		}}>

			<Group style={{ minWidth: 0, flex: 1 }}>
				<Text size="xs">&copy; 2024 Conduction, Inc. All rights reserved</Text>
				<Anchor href="https://docs.google.com/document/d/1ErgPJORWHHJrvAY8USGhaPG0Wa9AEa-O/edit?usp=sharing&ouid=115620778392196722500&rtpof=true&sd=true"
					target="blank"
					size="xs">
					COPPA Notice
				</Anchor>
			</Group>

			{!isMobile &&
				<Group style={{ minWidth: 0, flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 6 }}>
					<ActionIcon size="md" variant="subtle" radius="lg" component="a"
						href="https://www.instagram.com/conduction.live?igsh=MTV2cjdwbXU1djBmaQ==/"
						target="blank">
						<IconBrandInstagram size={18} stroke={1.5} />
					</ActionIcon>

					<ActionIcon size="md" variant="subtle" radius="xl" component="a"
						href="https://www.linkedin.com/company/conduction-live"
						target="blank">
						<IconBrandLinkedin size={18} stroke={1.5} />
					</ActionIcon>
				</Group>
			}
		</Flex>
	);
};

export default Footer;